var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadCloudIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.92,
    height: 28.556,
    viewBox: "0 0 29.92 28.556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6911",
    "data-name": "Group 6911",
    transform: "translate(-324.023 -407.388)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14464",
    "data-name": "Path 14464",
    d: "M353.764,420.935a7.5,7.5,0,0,0-6.955-5.511h-1.17a10.96,10.96,0,0,0-20.429-1.881c-1.842,3.836-1.5,9.775.759,13.24a.7.7,0,0,0,1.172-.765c-1.989-3.047-2.294-8.483-.677-11.852a9.565,9.565,0,0,1,17.954,2.119.7.7,0,0,0,.682.539h1.678a6.091,6.091,0,0,1,5.625,4.439,6.86,6.86,0,0,1-.908,5.052.7.7,0,0,0,.223.965.687.687,0,0,0,.37.107.7.7,0,0,0,.6-.329A8.289,8.289,0,0,0,353.764,420.935Z",
    fill: "#4b9ce2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14465",
    "data-name": "Path 14465",
    d: "M339.46,421.91a.72.72,0,0,0-.99,0l-5.7,5.706a.7.7,0,0,0,.99.99l4.515-4.516c0,.01,0,.018,0,.027v11.127a.7.7,0,1,0,1.4,0V424.117c0-.009-.005-.017-.005-.027l4.517,4.516a.7.7,0,0,0,.99-.99Zm-.495,1.507c-.01,0-.018.005-.027.005l.027-.026.027.026C338.982,423.422,338.974,423.417,338.965,423.417Z",
    fill: "#4b9ce2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloudIcon);
export default __webpack_public_path__ + "static/media/upload-cloud-icon.32d9fbe4b2b198165caed411888773b9.svg";
export { ForwardRef as ReactComponent };